import React from "react";
import { JobPipeline } from "./config/hiringConfig";

interface Props {
  data: JobPipeline[];
}

const PipelineTable: React.FC<Props> = ({ data }) => {
  if (!data || data.length === 0) {
    return <p className="text-gray-400">No pipeline data available.</p>;
  }

  // Safe extraction of stage headers
  const stages = data[0]?.stages?.map((s) => s.stage) ?? [];

  const rightShadowClass = "shadow-[4px_0_6px_-1px_rgba(0,0,0,0.1)]";

  return (
    <div className="flex bg-white rounded-lg overflow-hidden">
      {/* LEFT FIXED JOB COLUMN */}
      <div
        className={`sticky left-0 bg-white min-w-[180px] border-r border-gray-200 z-10 ${rightShadowClass}`}
      >
        {/* Header */}
        <div className="p-3 font-semibold text-sm h-[44px] flex items-center">
          Jobs
        </div>

        {/* Job rows */}
        {data.map((job) => (
          <div
            key={job.title}
            className="p-3 text-sm h-[80px] flex flex-col justify-center"
          >
            <div className="font-semibold">{job.title}</div>
            <div className="text-gray-400 text-xs">
              Total Applications: {job.totalApplications}
            </div>
          </div>
        ))}
      </div>

      {/* RIGHT SCROLLABLE STAGES */}
      <div className="overflow-x-auto flex-grow">
        <table className="min-w-max w-full border-collapse">
          <thead>
            <tr>
              {stages.map((stage) => (
                <th
                  key={stage}
                  className="p-3 text-left font-semibold text-sm min-w-[160px] h-[44px] whitespace-nowrap"
                >
                  {stage}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((job) => (
              <tr key={job.title} className="h-[80px]">
                {job.stages.map((s) => (
                  <td key={`${job.title}-${s.stage}`} className="p-2">
                    {s.count !== null && s.count !== undefined ? (
                      <div
                        className={`${s.color} text-white min-w-[150px] text-xs rounded-md px-4 py-4 text-center font-medium`}
                      >
                        {s.count} Candidates
                      </div>
                    ) : (
                      <div className="bg-gray-100 text-gray-400 min-w-[150px] text-xs rounded-md px-4 py-4 text-center">
                        No Candidates
                      </div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PipelineTable;
